var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4406 11.5991L20.4006 5.55909C19.134 4.29242 17.3873 3.61242 15.6006 3.70576L8.93395 4.02576C6.26728 4.14576 4.14728 6.26576 4.01395 8.91909L3.69395 15.5858C3.61395 17.3724 4.28062 19.1191 5.54728 20.3858L11.5873 26.4258C14.0673 28.9058 18.094 28.9058 20.5873 26.4258L26.4406 20.5724C28.934 18.1058 28.934 14.0791 26.4406 11.5991ZM12.6673 16.5058C10.5473 16.5058 8.82728 14.7858 8.82728 12.6658C8.82728 10.5458 10.5473 8.82576 12.6673 8.82576C14.7873 8.82576 16.5073 10.5458 16.5073 12.6658C16.5073 14.7858 14.7873 16.5058 12.6673 16.5058Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.8307ce35efb1f400abdc6a94f9228ceb.svg";
export { ForwardRef as ReactComponent };